import { Dimensions, StyleSheet } from 'react-native'
import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

const styles = {
  header: {
    padding: 16,
    fontSize: 22,
    lineHeight: 18
  },
  titleContainer: {
    paddingVertical: 24,
    paddingHorizontal: 16,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  suggestionRow: theme => ({
    overflow: 'hidden',
    backgroundColor: theme.colors.cardBackgroundColor
  }),
  currentLocation: theme => ({
    right: 16,
    padding: 4,
    bottom: 30,
    width: 'auto',
    borderRadius: 8,
    position: 'absolute',
    backgroundColor: theme.colors.primaryColor
  }),
  suggestionText: theme => ({
    color: theme.colors.textColor
  }),
  autocompleteText: theme => ({
    color: theme.colors.textColor
  }),
  textInputStyle: theme => ({
    flex: 1,
    height: 52,
    elevation: 2,
    width: '100%',
    paddingLeft: 10,
    paddingRight: 10,
    color: theme.colors.textColor,
    borderColor: theme.colors.borderColorThree,
    backgroundColor: theme.colors.quickActionGradientColors.secondary?.[0]
  }),
  noMargin: {
    flex: 1,
    margin: 0,
    padding: 0,
    width: '100%',
    position: 'relative'
  },
  autocomplete: {
    zIndex: 20,
    paddingTop: 8,
    elevation: 20,
    position: 'absolute',
    paddingHorizontal: 16
  },
  modal: (h, theme) => ({
    width: '100%',
    height: h * 0.85,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    backgroundColor: theme.colors.cardBackgroundColor
  }),
  modalContainer: {
    flex: 1,
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'flex-end'
  },
  description: {
    fontSize: 16,
    lineHeight: 20,
    paddingBottom: 16,
    paddingHorizontal: 16
  },
  primary: {
    margin: 16
  },
  secondary: {
    marginHorizontal: 16
  },
  container: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingBottom: 0
  },
  title: {
    fontSize: 24
  },
  notify: theme => ({
    bottom: 30,
    left: '2%',
    padding: 10,
    width: '95%',
    zIndex: 100,
    elevation: 6,
    borderRadius: 15,
    position: 'absolute',
    backgroundColor: theme.colors.cardBackgroundColor,
    shadowRadius: 8,
    shadowOpacity: 0.25,
    shadowColor: Colors.black,
    shadowOffset: { width: 0, height: 2 }
  }),
  map: {
    flexGrow: 1
  },
  mapView: {
    ...StyleSheet.absoluteFillObject
  },
  gpaContainer: w => ({
    flex: 1,
    width: w - 32
  }),
  button: w => ({
    flex: 1,
    bottom: 30,
    left: '5%',
    width: '90%',
    position: 'absolute'
  }),
  loader: height => ({
    zIndex: 1,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    height: height * (Dimensions.get('window').width > 700 ? 0.5 : 0.75),
    justifyContent: 'center'
  }),
  marker: {
    width: 72,
    height: 72
  }
}

export default styles
